import {XauditModel} from '../xaudit.model';
import {cfgTDOUser} from '../../modules/ar/_models/ar.models';
import {DataARTransactionItemModel} from './data-ar-transaction-item.model';
import {DataARPaymentDistribsModel} from './data-ar-payment-distribs.model';
import {CfgARAccountModel} from './cfg-ar-account.model';

export class DataARLedgerModel extends XauditModel {
  LedgerID: string;
  LOCID: number;
  PatientId: string;
  PostDate: Date;
  enumARLedgerItemTypeID: string;
  enumARLedgerItemOriginTypeID: string;
  ARTransactionItemID: string;
  Amount: number;
  Description: string;
  enumCurrencyID: string;
  ARAccountID: string;
  DoctorARLocId: string;
  enumLedgerItemStatusID: string;
  Reference: string;
  PaymetnID: string;
  ParentLedgerID: string;
  PostFeeGroup: string;
  IsWriteOffPresent: boolean;
  ARLedgerItemTypeReferenceObjectID: string;

  cfgARAccount: CfgARAccountModel;
  dataARTransactionItem: DataARTransactionItemModel;
  xauditCreateByUser: cfgTDOUser;
  dataARPaymentDistribs: DataARPaymentDistribsModel[];

  DATA_SELECTED: boolean;
  DATA_SELECTED_CLAIM: boolean;
  DATA_PAYMENT_AMOUNT: string;
  dataARPaymentDistrib: DataARPaymentDistribsModel;
  DATA_ENABLE_PRICE_EDIT: boolean;
  DATA_SHOW_NOTES: boolean;
  DATA_IS_IN_PLAN: boolean;
}
